var map = {
	"./es/announcements/list.json": [
		417,
		4
	],
	"./es/common.json": [
		418,
		5
	],
	"./es/degree-processes/documents.json": [
		419,
		6
	],
	"./es/degree-processes/main.json": [
		420,
		7
	],
	"./es/petitions.json": [
		421,
		8
	],
	"./es/study-plan-enrollment-status.json": [
		422,
		9
	],
	"./es/survey.json": [
		423,
		10
	],
	"./es/terms.json": [
		424,
		11
	],
	"./es/translation.json": [
		425,
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 304;
module.exports = webpackAsyncContext;